/**
 * Utility to extract promo code error from calculator results
 * @param calculatorResults Calculator Results from a cart response.
 * @return					Returns a promo code error message or undefined if not found.
 */
function getPromoCodeFieldValidationMessage (calculatorResults) {

	let error = '';

	const promoCodeErrorMessages = {
		PromoDiscountPromoCodeDoesNotExist: 'Not a valid code.',
		PromoDiscountPromotionDoesNotExist: 'Not a valid code.',
		PromoDiscountPromotionNotActive: 'Not a valid code.',
		PromoDiscountPromotionDateNotValid: 'Not a valid code.',
		PromoDiscountPromotionExpired: 'Expired code.',
		PromoDiscountPromotionNotValidForSite: 'Not a valid code.',
		PromoDiscountExceededMaxUsage: 'Not a valid code.',
		PromoDiscountUserDoesNotQualify: 'Not a valid code.',
		PromoDiscountPromoCodeInSameCategory: 'Not a valid code.',
		PromoDiscountInvalidPromotion: 'Not a valid code.'
	};

	_.find(calculatorResults, (result) => _.find(result.ErrorMessages, (errorMessage) => {

		Object.keys(promoCodeErrorMessages).forEach((id) => {

			if (id === errorMessage.MessageId) {

				error = promoCodeErrorMessages[id];

			}

		});

	}));

	return error;

}

export default getPromoCodeFieldValidationMessage;
